import { parseImage } from "../constants/parse/image";

// Basic Page url handler for path reconstruction
export const newsPageRouteConverter = (url, original, converted) => {
  return url.replace(original, converted);
};

export const parseNodes = (nodes) => {
  return nodes
    .valueSeq()
    .toArray()
    .filter((node) => node.getIn(["attributes", "path"]) !== null)
    .map((node) => ({
      title: node.get("title"),
      created: node.get("created"),
      description: node.get("description"),
      url: node.get("url"),
      image: parseImage(node.get("image")),
      category: node.get("category"),
      author: {
        name: node.getIn(["author", "name"]),
        image: parseImage(node.getIn(["author", "image"])),
        first_name: node.getIn(["author", "first_name"]),
        last_name: node.getIn(["author", "last_name"]),
      },
    }));
};
